<app-page>
  <app-page-header [ngClass]=AppConfig.theme>
    <app-page-title>{{ title }}</app-page-title>
    <app-page-actions>
      <app-course-add-button *appAuthorize="'isInstructor'">
        <button mat-fab class="add-course-btn" color="accent"
                [ngClass]=AppConfig.theme>
          <mat-icon>add</mat-icon>
        </button>
      </app-course-add-button>
    </app-page-actions>
  </app-page-header>
  <app-page-content>
    <app-course-list
      [filter]="filter | async"
      [courses]="service.visibleCourses$">
    </app-course-list>
  </app-page-content>
</app-page>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/courses/courses.component.html